import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Stack } from "react-bootstrap";
import Textarea from "../../../ui/Textarea";
import SelectFamily from "../../../ui/SelectFamily";
import DatePicker from "../../../ui/DatePicker";
import { User } from "../../../../types/user";
import SelectObject from "../../../ui/SelectObject";
import Input from "../../../ui/Input";

interface ExitState {
  note?: any;
  activeFamily: User[];
  familyUser: string;
  setFamilyUser: any;
  isBanned?: boolean;
  isDeleted?: boolean;
  isSelectedDisabled?: boolean;
  setUpdatedNote: any;
  setSaveIsEnabled: any;
  setUserToSave: any;
  myCase?: boolean;
  editNote?: boolean;
}

const Exit = ({
  note,
  activeFamily,
  familyUser,
  setFamilyUser,
  isBanned = false,
  isDeleted = false,
  isSelectedDisabled = false,
  setUpdatedNote,
  setSaveIsEnabled,
  setUserToSave,
  myCase,
  editNote = false,
}: ExitState) => {
  const mainRef = useRef();
  const [noteDate, setNoteDate] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  var types: any[] = [
    { id: 0, key: "voluntary", name: "Voluntary" },
    { id: 1, key: "involuntary", name: "Involuntary" },
  ];

  const handleScroll = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  };

  useEffect(() => {
    handleScroll(mainRef);

    if (editNote) {
      setNoteDate(note?.fields?.date);
      setType(note?.fields?.exit_type);
      setDescription(note?.fields?.description);
    } else {
      setNoteDate(new Date().toISOString().split("T")[0]);
    }
  }, []);

  useEffect(() => {
    const parts = familyUser.split("|");

    const note = {
      notetype: "exit",
      subject:
        familyUser !== "unassigned"
          ? {
              id: parts[0],
              type: parts[1],
            }
          : { id: 0 },
      fields: {
        date: noteDate,
        exit_type: type,
        description: description,
      },
    };

    setUpdatedNote(note);
  }, [familyUser, noteDate, type, description, setUpdatedNote]);

  const updateFamilyUser = (e: any) => {
    setFamilyUser(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  const updateDate = () => {
    setSaveIsEnabled(true);
    setUserToSave(true);
  };

  const updateType = (e: any) => {
    setType(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  const updateDescription = (e: any) => {
    setDescription(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  useEffect(() => {
    if (!noteDate) {
      setSaveIsEnabled(false);
      setUserToSave(false);
    }
  }, [noteDate]);

  return (
    <Stack gap={3} className="mt-4">
      <Row ref={mainRef}>
        {isSelectedDisabled || !myCase ? (
          <Col xs={6}>
            <Input
              label="Household Member"
              type="text"
              value={familyUser.split("|")[2]}
              cssInput={isDeleted || isBanned ? "app-danger-text" : ""}
              disabled={true}
            />
          </Col>
        ) : (
          <SelectFamily
            family={activeFamily}
            familyUser={familyUser ? familyUser : "unassigned"}
            updateFamilyUser={updateFamilyUser}
            defaultSelection="Unassigned"
          />
        )}
        <Col className="col-lg-4 col-md-6 col-sm-8">
          <DatePicker
            label="Date"
            currentValue={noteDate}
            setCurrentValue={setNoteDate}
            onUpdate={() => updateDate()}
            required={true}
            hasMaxDate={true}
            disabled={myCase ? false : true}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-lg-4 col-md-6 col-sm-8">
          <SelectObject
            label="Exit Type"
            value={type}
            options={types}
            onUpdate={(e: any) => updateType(e)}
            disabled={myCase ? false : true}
            cssClasses="text-wrap"
          />
        </Col>
      </Row>
      <Row className="mb-5">
        <Col xs={12}>
          <Textarea label="Description" value={description} onUpdate={(e: any) => updateDescription(e)} disabled={myCase ? false : true} />
        </Col>
      </Row>
    </Stack>
  );
};

export default Exit;
